import { T_VuParamsActionState } from "../Reports/DashboardVuParams"

const NoFilter = (props: any) => {
    const { isAggrigateLoading, action } = props

    const getFormedText = (action: T_VuParamsActionState)=>{
        let text = ""
        switch (action) {
            case "addmeasure":
            case "updateMeasure":
                text = 'Select a measure on the left to see its aggregate options'
                break

            case "addfilter":
            case "updateFilter":
                text = 'Select a filter on the left to see its options.'
                break

            case "addcolumn":
            case "updateColumn":
            case "addrow":
            case "updateRow":
                text = 'Select a dimension on the left to see its binning options.'
                break

        }

        return text
    }
    let formedTextBasedONAction = getFormedText(action)
        

    return (
        <>
            {isAggrigateLoading && <div className="padding-medium medium">Loading...</div>} 
            {/* FIXME: */}
            {!isAggrigateLoading && (
                <div className="padding-medium medium">
                    {formedTextBasedONAction}
                </div>
            )}
        </>
    )
}

export default NoFilter
